/*
 * UI/UX改善: モバイルフローティングCTA
 * スクロールしても常に「無料相談」ボタンが表示される（モバイルのみ）
 * ヒーローセクションを過ぎた後に表示、CTAセクション付近で非表示
 * safe-area-inset-bottom対応、タッチターゲット48px確保
 */

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { scrollToContactForm } from "@/hooks/useScrollToContact";

export function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      // Show after scrolling past 500px, hide near bottom (last 400px)
      const nearBottom = scrollY + winHeight > docHeight - 400;
      setVisible(scrollY > 500 && !nearBottom);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.25 }}
          className="fixed bottom-0 left-0 right-0 z-40 lg:hidden"
        >
          <div
            className="bg-white/95 backdrop-blur-sm border-t border-[#E0E0E0] px-4 py-3 shadow-[0_-4px_24px_rgba(0,0,0,0.08)]"
            style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom, 0px))" }}
          >
            <button
              onClick={() => scrollToContactForm()}
              aria-label="無料相談を予約する"
              className="flex items-center justify-center gap-2 w-full py-3.5 bg-[#E03030] text-white font-bold text-sm rounded hover:bg-[#c72828] transition-colors duration-200 active:scale-[0.98] touch-manipulation"
            >
              <MessageCircle size={16} />
              無料相談を予約する
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
